import Container from './ScheduleBatch.container';
import ScheduleBatch from './ScheduleBatch';

export default Container(ScheduleBatch);
